import { render, staticRenderFns } from "./conactus.vue?vue&type=template&id=5cfcbb62&"
import script from "./conactus.vue?vue&type=script&lang=js&"
export * from "./conactus.vue?vue&type=script&lang=js&"
import style0 from "./conactus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports